import { takeLatest, put, call } from 'redux-saga/effects'
import jwt_decode from 'jwt-decode'
import isURL from 'validator/lib/isURL'
import { camelizeKeys } from 'humps'

import { getJWT } from 'helpers/cookies.helper'
import { IUserModel } from 'models/user.model'
import canView from 'api/access/CanView'
import * as fromActions from '../../actions/user.action'

async function canViewLms() {
  return await canView()
}

function* decodeJwtEffectSaga() {
  try {
    const jwt = getJWT()
    if (jwt === '') {
      window.location.href = process.env.REACT_APP_LOGIN_URL as string
    } else {
      const viewResponse = yield call(canViewLms)
      if (viewResponse.canView) {
        const userData = camelizeKeys(jwt_decode(jwt)) as unknown as IUserModel
        let avatarUrl = 'assets/avatar-loading-xxl.svg'
        if (userData.avatar)
          if (isURL(userData.avatar, { require_protocol: true }))
            avatarUrl = userData.avatar
          else
            avatarUrl = `${process.env.REACT_APP_USER_AVATAR_PREFIX}${userData.avatar}`
        yield put(
          fromActions.Actions.updateUser({ ...userData, avatar: avatarUrl })
        )
      } else {
        window.location.href = process.env.REACT_APP_LOGIN_URL as string
      }
    }
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* decodeJwtWatcherSaga() {
  yield takeLatest(fromActions.DECODE_JWT, decodeJwtEffectSaga)
}
